import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "form-horizontal",
  role: "form"
}
const _hoisted_2 = { class: "form-body" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "error-msg" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "control-label" }
const _hoisted_12 = {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "error-msg" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6 mt-5" }
const _hoisted_18 = { class: "control-label" }
const _hoisted_19 = {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_20 = { value: "1" }
const _hoisted_21 = { value: "0" }
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = { class: "col-md-6 mt-5" }
const _hoisted_24 = { class: "control-label" }
const _hoisted_25 = {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_26 = { value: "1" }
const _hoisted_27 = { value: "0" }
const _hoisted_28 = { class: "error-msg" }
const _hoisted_29 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "core",
    nested: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(this.isEdit ? _ctx.$t('geoFencingEvents.editItemHeadline') : _ctx.$t('geoFencingEvents.addItemHeadline')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('geoFencingEvents.vehicleRegistration')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-control input-sm", { 'custom-error': _ctx.v.geoFencingEvents.vehicleId.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v.geoFencingEvents.vehicleId.$model) = $event))
                }, [
                  _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t('geoFencingEvents.selectPlaceholder')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicles, (vehicle) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: vehicle.id,
                      value: vehicle.id
                    }, _toDisplayString(vehicle.registration), 9, _hoisted_8))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _ctx.v.geoFencingEvents.vehicleId.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.geoFencingEvents.vehicleId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('geoFencingEvents.geoFencingName')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-control input-sm", { 'custom-error': _ctx.v.geoFencingEvents.geofencingId.$error }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v.geoFencingEvents.geofencingId.$model) = $event))
                }, [
                  _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('geoFencingEvents.selectPlaceholder')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.geofencings, (geofencing) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: geofencing.id,
                      value: geofencing.id
                    }, _toDisplayString(geofencing.name), 9, _hoisted_13))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _ctx.v.geoFencingEvents.geofencingId.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.geoFencingEvents.geofencingId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('geoFencingEvents.type')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-control input-sm", { 'custom-error': _ctx.v.geoFencingEvents.typeId.$error }]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v.geoFencingEvents.typeId.$model) = $event))
                }, [
                  _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('geoFencingEvents.selectPlaceholder')), 1),
                  _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t('geoFencingEvents.typeIn')), 1),
                  _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('geoFencingEvents.typeOut')), 1)
                ], 2), [
                  [_vModelSelect, _ctx.v.geoFencingEvents.typeId.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.geoFencingEvents.typeId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('geoFencingEvents.state')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-control input-sm", { 'custom-error': _ctx.v.geoFencingEvents.stateId.$error }]),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v.geoFencingEvents.stateId.$model) = $event))
                }, [
                  _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t('geoFencingEvents.selectPlaceholder')), 1),
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('geoFencingEvents.stateActive')), 1),
                  _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('geoFencingEvents.stateDeactive')), 1)
                ], 2), [
                  [_vModelSelect, _ctx.v.geoFencingEvents.stateId.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.geoFencingEvents.stateId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_28, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-remove" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.modals.exit')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.editGeoFencingEvents && _ctx.editGeoFencingEvents(...args)))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-save" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.modals.save')), 1)
        ]),
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-danger float-right",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeItem(this.geoFencingEvents.id)))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-remove" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('components.sentGeo.dataGrids.delete')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}